<template>
  <div class="card">
    <div class="card-header"><i class="icon-link"></i> Relation Axonaut</div>
    <div class="card-block">
      <div v-if="client.axonaut && client.axonaut.axonautCompanyId">
        Client lié à Axonaut (ID société :
        {{ client.axonaut.axonautCompanyId }})

        <div class="row mt-1">
          <div class="col-sm-6">
            <a
              :href="`https://axonaut.com/business/company/show/${client.axonaut.axonautCompanyId}`"
              target="_blank"
              class="btn btn-primary btn-block"
            >
              Voir la société dans Axonaut
            </a>
          </div>

          <div class="col-sm-6">
            <button
              class="btn btn-danger btn-block"
              :disabled="loading"
              @click="deleteRelation()"
            >
              Détacher la relation avec Axonaut
              <i v-if="loading" class="fa fa-spinner fa-spin"></i>
            </button>
          </div>
        </div>
      </div>

      <div
        v-else-if="
          axonautCompaniesOptions && axonautCompaniesOptions.length > 0
        "
      >
        <label>Ajouter une relation avec Axonaut :</label>

        <el-select
          v-model="axonautCompanyId"
          placeholder="Sélectionner une société dans la liste"
          class="w-100"
        >
          <el-option
            v-for="company in axonautCompaniesOptions"
            :key="company.value"
            :label="company.label"
            :value="company.value"
          ></el-option>
        </el-select>

        <div class="row mt-1">
          <div class="col-sm-6">
            <button
              class="btn btn-warning btn-block"
              :disabled="loading"
              @click="axonautCompaniesOptions = undefined"
            >
              Rechercher une autre société
            </button>
          </div>

          <div class="col-sm-6">
            <button
              class="btn btn-success btn-block"
              :disabled="loading || !axonautCompanyId"
              @click="createRelation()"
            >
              Créer la relation avec Axonaut
              <i v-if="loading" class="fa fa-spinner fa-spin"></i>
            </button>
          </div>
        </div>
      </div>

      <div v-else>
        <label>Ajouter une relation avec Axonaut :</label>

        <input
          placeholder="Renseigner le nom d'une société"
          type="text"
          class="form-control"
          v-model="axonautCompanyName"
          v-on:keyup.enter="getAxonautCompanies"
        />

        <button
          class="btn btn-success btn-block mt-2"
          :disabled="loading"
          @click="getAxonautCompanies"
        >
          Chercher la société sur axonaut
          <i v-if="loading" class="fa fa-spinner fa-spin"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    clientData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      client: undefined,
      axonautCompanyName: undefined,
      axonautCompaniesOptions: undefined,
      axonautCompanyId: undefined,
    };
  },

  watch: {
    clientData(newValue) {
      this.client = newValue;
    },
  },

  created() {
    this.client = this.clientData;
  },

  methods: {
    async getAxonautCompanies() {
      try {
        this.loading = true;

        const { data } = await this.$api.get(
          `/axonaut/axonaut-companies?name=${this.axonautCompanyName}`
        );

        if (data.length === 0) {
          this.$warningToast(
            "Aucune société trouvée dans Axonaut avec ce nom."
          );

          return;
        }

        this.axonautCompaniesOptions = data.map(({ id, name }) => ({
          value: id,
          label: name,
        }));
      } catch (error) {
        this.$errorToast(
          "Une erreur est survenue lors de la recherche des sociétés Axonaut."
        );
      } finally {
        this.loading = false;
      }
    },

    async deleteRelation() {
      try {
        this.loading = true;

        await this.$api.delete(`/axonaut/client-relation`, {
          data: {
            clientEmail: this.client.email,
            axonautClientId: this.client.axonaut.axonautClientId,
          },
        });

        this.client.axonaut = undefined;
        this.$successToast("Relation Axonaut supprimée avec succès.");
      } catch (e) {
        this.$errorToast(
          "Une erreur est survenue lors de la suppression de la relation Axonaut.",
          e
        );
      } finally {
        this.loading = false;
      }
    },

    async createRelation() {
      try {
        this.loading = true;

        const { data } = await this.$api.post(`/axonaut/client-relation`, {
          clientEmail: this.client.email,
          axonautCompanyId: this.axonautCompanyId,
        });

        this.client = {
          ...this.client,
          axonaut: data,
        };
        this.axonautCompaniesOptions = undefined;
        this.axonautCompanyId = undefined;
        this.axonautCompanyName = undefined;
        this.$successToast("Relation Axonaut créée avec succès.");
      } catch (e) {
        this.$errorToast(
          "Une erreur est survenue lors de la création de la relation Axonaut.",
          e
        );
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
